import type { ReactNode } from 'react'
import type { RubricCriterion, RubricLayout } from '@/lib/types'
import { sectionsFor } from '@/lib/rubricLayout'
import { RubricOutline } from './RubricOutline'

export function RubricView({ rubric, layout, emptyText = 'No rubric yet.', renderCriterion, criterionClassName }: {
  rubric: RubricCriterion[]; layout?: RubricLayout; emptyText?: string
  criterionClassName?: (criterion: RubricCriterion) => string
  renderCriterion?: (criterion: RubricCriterion) => ReactNode
}) {
  if (!rubric?.length) return <p className="empty">{emptyText}</p>
  const byId = new Map(rubric.map(c => [c.criterion_id, c]))
  return <RubricOutline sections={sectionsFor(rubric, layout)} text={id => `${byId.get(id)?.criterion ?? ''} ${byId.get(id)?.evidence ?? ''}`}>
    {(_section, ids) => <ol className="rubric">{ids.map(id => {
      const c = byId.get(id)!
      return renderCriterion ? <li key={id} className={criterionClassName?.(c)}>{renderCriterion(c)}</li> : <li key={id}>
        <span className="id">{id}</span><div><div className="crit">{c.criterion}</div>
          <div className="tags"><span className={`chip ${c.role === 'required' ? 'neutral' : c.role === 'bonus' ? 'ok' : 'err'}`}>{c.role}</span></div>
          {c.evidence && <div className="detail"><b>Check:</b> {c.evidence}</div>}
        </div>
      </li>
    })}</ol>}
  </RubricOutline>
}
